import classNames from 'classnames';
import { forwardRef } from 'react';
import CalendarIcon from '../assets/calendar.svg';
const promptBlueBoxCss = "p1b38ivv";
export const PromptBlueBox = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(promptBlueBoxCss, props.className)} />;
});
const calendarIconImageCss = "claq00x";
export const CalendarIconImage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const src = CalendarIcon;
  return <Component ref={ref} {...restProps} src={src} aria-hidden className={classNames(calendarIconImageCss, props.className)} />;
});
const italicTextCss = "iwyqp1i";
export const ItalicText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(italicTextCss, props.className)} />;
});
const meetingHistorySectionHeaderCss = "m1mx3ife";
export const MeetingHistorySectionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(meetingHistorySectionHeaderCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");